import globalTheme, { muiTheme } from '../global'

const Rating = {
	MuiRating: {
		styleOverrides: {
			root: {
				color: globalTheme.palette.rating.main,
				'& > span': {
					paddingRight: globalTheme.spacing(0.625),
				},
				'& .MuiSvgIcon-root': {
					fontSize: muiTheme.typography.pxToRem(18),
				},
			},
			iconEmpty: {
				color: globalTheme.palette.rating.main,
			},
			label: {
				paddingRight: 5,
			},

			sizeSmall: {
				'& .MuiSvgIcon-root': {
					fontSize: muiTheme.typography.pxToRem(14),
				},
			},
			sizeMedium: {
				'& .MuiSvgIcon-root': {
					fontSize: muiTheme.typography.pxToRem(16),
					[globalTheme.breakpoints.up('md')]: {
						fontSize: muiTheme.typography.pxToRem(24),
					},
				},
			},
			sizeLarge: {
				'& .MuiSvgIcon-root': {
					fontSize: muiTheme.typography.pxToRem(32),
				},
			},
		},
	},
}

export default Rating
